import { HeaderNavLink as e, navLinkClassName as t } from "../base/HeaderLink.js";
import { useHeaderVisible as n } from "../base/HeaderRoot.js";
import { getAriaProps as r, getLevelState as i, handleMouseEnter as a, handleMouseLeave as o, resetLevelStates as s } from "../navState.js";
import { useNavLevels as c } from "../useNavLevels.js";
import { DesktopNavLevel3 as l } from "./DesktopNavLevel3.js";
import { DesktopNavLevel2 as u } from "./DesktopNavLevel2.js";
import { useEffect as d, useRef as f } from "react";
import p from "clsx";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
//#region src/components/Header/desktop/DesktopNav.tsx
function _({ items: e, active: t, resetKey: r, openOnHover: i = !0, linkComponent: a, openMenuLabel: o, onOverlayChange: l, onSecondLevelOpenChange: u, children: _, className: y }) {
	let b = n(), [x, S, C] = c(e, t, r), w = f(void 0);
	d(() => {
		b || s(S);
	}, [b, S]);
	let T = x.some((e) => e.levelIndex === 2 && e.isShown && e.hasContent);
	return d(() => {
		if (l?.(T), T) return document.body.classList.add("overflow-hidden"), () => {
			l?.(!1), document.body.classList.remove("overflow-hidden");
		};
	}, [T, l]), d(() => {
		u?.(C);
	}, [C, u]), /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ g("nav", {
		className: p("relative flex w-full justify-between", y),
		children: [/* @__PURE__ */ h("ul", {
			className: "flex w-full gap-5",
			children: e.map((e) => /* @__PURE__ */ h(v, {
				item: e,
				levelStates: x,
				setLevelStates: S,
				mouseLeaveTimeout: w,
				openOnHover: i,
				linkComponent: a,
				openMenuLabel: o
			}, e.key))
		}), _ ? /* @__PURE__ */ h("div", {
			className: "flex shrink-0 gap-5",
			children: _
		}) : null]
	}), C && /* @__PURE__ */ h("div", { className: "h-[var(--navigation-second-level-height)] w-full" })] });
}
function v({ item: n, levelStates: s, setLevelStates: c, mouseLeaveTimeout: d, openOnHover: f, linkComponent: p, openMenuLabel: m }) {
	let _ = i(s, n.key);
	if (!_) return null;
	let v = () => a(d, c, _), y = () => o(d, c, _);
	return /* @__PURE__ */ g("li", {
		onMouseEnter: f ? v : void 0,
		onFocus: f ? v : void 0,
		onMouseLeave: f ? y : void 0,
		onBlur: f ? y : void 0,
		children: [n.link ? /* @__PURE__ */ h(e, {
			isActive: _.isShown,
			link: n.link,
			linkComponent: p,
			...r(_, n.label, m),
			children: n.label
		}) : /* @__PURE__ */ h("button", {
			className: t(_.isShown),
			"aria-expanded": _.hasContent ? _.isShown : void 0,
			children: n.label
		}), n.children ? /* @__PURE__ */ h(u, {
			items: n.children,
			currentLevelState: _,
			nextLevelStates: s.filter((e) => e.parentKey === _.key),
			setLevelStates: c,
			mouseLeaveTimeout: d,
			linkComponent: p,
			openMenuLabel: m
		}) : n.columns ? /* @__PURE__ */ h(l, {
			columns: n.columns,
			isShown: _.isShown,
			className: "top-[calc(100%+0.5rem)]!",
			teaser: n.teaser,
			linkComponent: p
		}) : null]
	});
}
//#endregion
export { _ as DesktopNav };
